// src/components/Navbar.js
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/favicon.ico";
import "./Navbar.css";
import React, { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [mobileInfoOpen, setMobileInfoOpen] = useState(false);

  const navLinkClass = ({ isActive }) =>
    isActive ? "text-red-600" : "text-gray-800 hover:text-red-600";

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Erdwärme-Experten" className="w-8 h-8" />
          <span className="text-lg font-semibold text-gray-900">
            Erdwärme-Experten
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8 font-medium">
          <NavLink to="/" end className={navLinkClass}>
            Start
          </NavLink>

          {/* Dropdown Informationen */}
          <div
            className="relative"
            onMouseEnter={() => setInfoOpen(true)}
            onMouseLeave={() => setInfoOpen(false)}
          >
            <button
              type="button"
              aria-haspopup="true"
              aria-expanded={infoOpen}
              className="flex items-center gap-1 text-gray-800 hover:text-red-600"
            >
              Informationen
              <ChevronDown
                className={`w-4 h-4 transition-transform ${
                  infoOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {infoOpen && (
              <div className="absolute left-0 top-full pt-3">
                <div className="w-64 rounded-2xl border border-gray-200 bg-white shadow-lg p-2">
                  <NavLink
                    to="/flache-geothermie"
                    className="block px-4 py-3 rounded-xl text-gray-700 hover:bg-gray-50 hover:text-red-600"
                  >
                    Flache Geothermie
                  </NavLink>

                  <NavLink
                    to="/erdwaermepumpe-kosten"
                    className="block px-4 py-3 rounded-xl text-gray-700 hover:bg-gray-50 hover:text-red-600"
                  >
                    Kostenvergleich
                  </NavLink>

                  <NavLink
                    to="/bundeslaender"
                    className="block px-4 py-3 rounded-xl text-gray-700 hover:bg-gray-50 hover:text-red-600"
                  >
                    Bundesländer & Regelungen
                  </NavLink>
                </div>
              </div>
            )}
          </div>

          <NavLink to="/report" className={navLinkClass}>
            GeoReport
          </NavLink>

          <NavLink to="/faq" className={navLinkClass}>
            FAQ
          </NavLink>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          className="md:hidden p-2"
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <div className="md:hidden bg-white border-t shadow-sm">
          <nav className="flex flex-col px-6 py-4 gap-2 text-gray-700 font-medium">
            <Link to="/" onClick={() => setOpen(false)} className="py-2">
              Start
            </Link>

            {/* Mobile Informationen */}
            <button
              type="button"
              onClick={() => setMobileInfoOpen(!mobileInfoOpen)}
              className="flex items-center justify-between py-2 text-left"
            >
              <span>Informationen</span>
              <ChevronDown
                className={`w-4 h-4 transition-transform ${
                  mobileInfoOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {mobileInfoOpen && (
              <div className="ml-4 flex flex-col gap-2 pb-2 text-sm">
                <Link to="/flache-geothermie" onClick={() => setOpen(false)}>
                  Flache Geothermie
                </Link>
                <Link to="/erdwaermepumpe-kosten" onClick={() => setOpen(false)}>
                  Kostenvergleich
                </Link>
                <Link to="/bundeslaender" onClick={() => setOpen(false)}>
                  Bundesländer & Regelungen
                </Link>
              </div>
            )}

            <Link to="/report" onClick={() => setOpen(false)} className="py-2">
              GeoReport
            </Link>

            <Link to="/faq" onClick={() => setOpen(false)} className="py-2">
              FAQ
            </Link>

            <Link to="/agb" onClick={() => setOpen(false)} className="py-2">
              AGB
            </Link>

            <Link to="/impressum" onClick={() => setOpen(false)} className="py-2">
              Impressum
            </Link>
          </nav>
        </div>
      )}
    </nav>
  );
}
